import { ReactNode } from 'react';

export enum AssetTypes {
    movie = 'movie',
    movies = 'Movies',
    tvod = 'TVOD',
    svod = 'SVOD',
    episode = 'Episode',
    vod_episode = 'vod_episode',
    vod_asset = 'vod_asset',
    tv_series_episode = 'tv_series_episode',
    listing = 'listing',
    series = 'series',
    channel = 'channel',
    program = 'program',
    program_series = 'program_series',
    person = 'person',
    director = 'director',
    now_next = 'TV_NOW_NEXT',
    recording = 'recording',
    placeholder = 'placeholder',
    continue_watching = 'continue_watching',
    show = 'Show',
    vod_series = 'vod_series',
}

export enum AssetTypesGS {
    VOD_ASSET = 'VOD_ASSET',
    VOD_SERIES = 'VOD_SERIES',
    PROGRAM = 'PROGRAM',
    PROGRAM_SERIES = 'PROGRAM_SERIES',
    COLLECTION = 'COLLECTION',
    LISTING = 'LISTING',
    RECORDING = 'RECORDING',
}

export enum CardContext {
    STRIPE = 'stripe',
    COLLECTION = 'collection',
}

export enum StripeTypes {
    EDITORIAL = 'editorial',
    GALLERY = 'gallery',
    // @Deprecated use PORTRAIT
    MOVIE = 'movie',
    PORTRAIT = 'portrait',
    MIXED = 'mixed',
    PROGRAM = 'program',
    RECORDING = 'recording',
    // @Deprecated, use ROUNDED
    PERSON = 'person',
    ROUNDED = 'rounded',
    EPISODE = 'episode',
    TV_SERIES_EPISODE = 'tv_series_episode',
    TV_CHANNEL = 'tv_channel',
    NOW_NEXT = 'TV_NOW_NEXT',
}

export enum StripeVarietyGS {
    STRIPE = 'Stripe',
    COLLECTION = 'collection',
    COLLECTIONS = 'Collections', // todo handle this type
}

export enum ModuleType {
    CHANNEL = 'CHANNEL',
    TV_CHANNEL = 'TV_CHANNEL',
    GALLERY = 'GALLERY',
    MIXED = 'MIXED',
    BANNER = 'BANNER',
    DYNAMIC = 'DYNAMIC',
    VOD_MOVIE = 'VOD_MOVIE',
    NOW_AND_NEXT = 'TV_NOW_NEXT',
    GENRE_EDITORIAL = 'GENRE_EDITORIAL',
    EDITORIAL = 'EDITORIAL',
    LANDSCAPE = 'LANDSCAPE',
    COLLECTIONS = 'COLLECTIONS',
    PORTRAIT = 'PORTRAIT',
    ROUNDED = 'ROUNDED',
}

export enum ImageAspectRatio {
    LANDSCAPE = '16:9',
    PORTRAIT = '2:3',
    ROUNDED = '1:1',
}

export enum ViewType {
    EPG = 'EPG',
}

export enum ModuleTypes {
    STRIPE = 'stripe',
    GALLERY = 'gallery',
    COLLECTION = 'collection',
    REPEATER = 'repeater',
    EPG = 'epg',
}

export type HelmetData = {
    title: string;
    openGraph: {
        'og:title': string;
        'og:site_name': string;
        'og:locale': string;
        'og:url'?: string;
        'og:type'?: string;
        'og:image'?: string;
        'og:description'?: string;
    };
    canonicalLink?: string;
    description?: string;
    jsonLd?: Record<string, unknown>;
    robots?: string | 'all' | 'none'; // all possible values: https://ahrefs.com/blog/meta-robots/
    children?: ReactNode;
};

export type AspectRatio = {
    width: number;
    height: number;
};

export enum KeyboardActions {
    ENTER = 'Enter',
}
